import { render, staticRenderFns } from "./OthersDeals.vue?vue&type=template&id=fc360554&scoped=true&"
import script from "./OthersDeals.vue?vue&type=script&lang=js&"
export * from "./OthersDeals.vue?vue&type=script&lang=js&"
import style0 from "./OthersDeals.vue?vue&type=style&index=0&id=fc360554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc360554",
  null
  
)

export default component.exports